import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-6 space-y-4 break-inside-avoid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium" }, "Forløb overblik", -1)
const _hoisted_3 = { class: "bg-white rounded-md" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTable = _resolveComponent("GenericTable")!
  const _component_CourseThemesModal = _resolveComponent("CourseThemesModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_GenericTable, {
        "clickable-rows": "",
        headers: _ctx.headers,
        items: _ctx.items,
        "pinned-bottom-row-data": _ctx.pinnedBottomRowData,
        onItemClicked: _ctx.onCourseClicked
      }, null, 8, ["headers", "items", "pinned-bottom-row-data", "onItemClicked"]),
      _createVNode(_component_CourseThemesModal, { "selected-course": _ctx.selectedModalCourse }, {
        toggle: _withCtx(({ open }) => [
          _createElementVNode("input", {
            ref: "modal-input",
            class: "hidden",
            type: "hidden",
            onClick: open
          }, null, 8, _hoisted_4)
        ]),
        _: 1
      }, 8, ["selected-course"])
    ])
  ]))
}